import $ from 'jquery';

// Create a button for manually submitting FacetWP search
$('[data-facetwp-search]').on('click', () => {
  FWP.refresh();
});



// WEBPACK FOOTER //
// ./assets/js/site/vendor-facetwp.js